<template>
    <v-sheet outlined class="example">
        <v-toolbar flat density="compact" height="48px" class="grey lighten-4 border-b">
            <v-slide-group class="flex-grow-1">
                <slot name="toolbar" />
            </v-slide-group>

            <v-btn icon text class="text-medium-emphasis" @click="editable = !editable">
                <i class="mdi-chevron-up mdi v-icon v-icon--size-default" aria-hidden="true" />
            </v-btn>
        </v-toolbar>

        <v-divider/>

        <v-layout>
            <v-main class="pa-8">
                <v-sheet min-height="300px" class="d-flex align-center">
                    <div class="flex-fill">
                        <div class="text-center">
                            <slot name="render" />
                        </div>
                    </div>
                </v-sheet>
            </v-main>
        </v-layout>

        <template v-if="editable">
            <v-divider/>

            <v-card-text>
                <slot name="editor" />
            </v-card-text>
        </template>

    </v-sheet>
</template>

<script>
export default {
    props: {
        editable: { type: Boolean, default: true }
    }
}
</script>